const initShowMoreButton = (container, visibleItems) => {
  const itemsContainer = document.querySelector(container);
  if (!itemsContainer) return;
  const showMoreButton = itemsContainer.querySelector("[data-show-button]");
  const items = Array.from(itemsContainer.querySelectorAll("[data-collapse-item]")).filter((item) => item.style.display !== "none");
  const hiddenItems = items.slice(visibleItems);

  const onShowMoreButtonClick = () => {
    hiddenItems.forEach((item) => {
      item.style.display = null;
      setTimeout(() => item.style.opacity = 1, 250);
    });
    showMoreButton.textContent = "Свернуть";
    showMoreButton.removeEventListener("click", onShowMoreButtonClick);
    showMoreButton.addEventListener("click", onCollapseButtonClick);
  };

  const onCollapseButtonClick = () => {
    hiddenItems.forEach((item) => {
      setTimeout(() => item.style.display = 'none', 250);
      item.style.opacity = 0;
    });
    showMoreButton.textContent = "Показать всю программу";
    showMoreButton.removeEventListener("click", onCollapseButtonClick);
    showMoreButton.addEventListener("click", onShowMoreButtonClick);
  };

  if (items.length <= visibleItems) {
    showMoreButton?.classList.add("hidden");
    return;
  };

  hiddenItems.forEach((item) => {
    item.style.display = 'none';
    item.style.opacity = 0;
  });

  showMoreButton?.addEventListener("click", onShowMoreButtonClick);
};

export default initShowMoreButton;
